import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { sweetAlert } from 'src/app/utils/swal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  showPassword = false;
  signInForm!: FormGroup;
  submitted = false;
  isCompany = true;
  passwordToggleFlag = true;


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route : ActivatedRoute
  ) { }

 ngOnInit(): void {
  this.route.queryParams.subscribe((params: any) => {
    const isLogout = params['logout'] === 'true';

    if (isLogout) {
      // Clear token
      this.authService.removeToken('token');

      // Replace URL to remove query param
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    // Auto redirect if already logged in
    const token = this.authService.getToken('token');
    if (token) {
      window.open(`${environment.PROVIDER_PANEL_URL}auth-token/${token}`, '_self');
      return;
    }

    // Initialize login form only if not redirected
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
      roles: [this.isCompany ? 'company' : 'staff']
    });
  });
}


  onSignIn() {
    this.submitted = true;

    if (this.signInForm.invalid) {
      return;
    }

    const payload = {
      ...this.signInForm.value,
    }

    this.authService
      .signin(payload)
      .subscribe(data => {
        if (!data.success) {
          sweetAlert("Error", data.message, "error", "Ok");
          return;
        }
        if (data && data.token) {
          
          this.authService.setToken('token', data.token);

          if(environment.production){
            window.open(`${environment.PROVIDER_PANEL_URL}auth-token/${data.token}`,'_self');
          }
          else{
            window.open(`${environment.PROVIDER_PANEL_URL}auth-token/${data.token}`,'_self');
          }
        } else {
          
        }
      },(err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  get form() {
    return this.signInForm.controls;
  }

  ngOnDestroy() {
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  toggleRole() {
  this.isCompany = !this.isCompany;
  this.signInForm.patchValue({
    roles: this.isCompany ? 'company' : 'staff'
  });
}

}
